module.exports = __webpack_public_path__ + "static/media/md-moon.99ab2f96.svg";